import React from "react";
import MultiSelectInput from "components/MainApp/atoms/Forms/MultiSelectInput";
import Toggle from "components/MainApp/atoms/Forms/Toggle";

import styles from "./MainApp.organisms.DeviceSelector.module.scss";
import i18n from "i18n";

const DeviceSelector = ({
  devices,
  selected,
  handleToggleChange,
  disableToggle,
  checked,
  handleChange,
  handleOpen,
  handleClose,
  maxDevicesSelected,
}) => {
  return (
    <div className={styles["device-selector-root"]}>
      <div className={styles["input-wrapper"]}>
        <MultiSelectInput
          items={devices}
          selected={selected}
          label={i18n.t("devices")}
          required={false}
          handleChange={handleChange}
          handleClose={handleClose}
          handleOpen={handleOpen}
          maxDevicesSelected={maxDevicesSelected}
        ></MultiSelectInput>
      </div>
      <div className={`${styles["toggle-wrapper"]} global-toggle-wrapper`}>
        <p>
           <span>{checked ? i18n.t("reading.enabled") : i18n.t("reading.disabled")}</span>
        </p>
        <Toggle
          handleChange={handleToggleChange}
          checked={checked}
          disabled={disableToggle}
          name="channel"
        />
      </div>
    </div>
  );
};

export default DeviceSelector;
